// Static content config — do not store this in localStorage

export const BARAKAH_HABITS = [
  {
    id: "tahajjud",
    timeOfDay: "night_pre_fajr",
    name: "Tahajjud",
    arabicName: "تهجد",
    transliteration: "Tahajjud",
    type: "prayer",
    shortDescription: "Night prayer before Fajr",
    whyItMatters: "The Prophet ﷺ said Allah descends to the lowest heaven in the last third of the night, saying: Who is calling upon Me that I may answer? Who is asking that I may give? Scholars across generations have linked qiyam al-layl to barakah in provision, clarity of heart, and closeness to Allah. Even two rakʿahs is a beginning.",
    source: "Sahih al-Bukhari, Sahih Muslim",
  },
  {
    id: "witr",
    timeOfDay: "night_pre_fajr",
    name: "Witr",
    arabicName: "وتر",
    transliteration: "Witr",
    type: "prayer",
    shortDescription: "Close the night in connection",
    whyItMatters: "The Prophet ﷺ never abandoned witr, even while travelling. It seals the night's prayer and keeps the heart oriented toward Allah before sleep ends.",
    source: "Sahih al-Bukhari",
  },
  {
    id: "morning_adhkar",
    timeOfDay: "after_fajr",
    name: "Morning adhkar",
    arabicName: "أذكار الصباح",
    transliteration: "Adhkar al-Sabah",
    type: "dhikr",
    shortDescription: "The morning remembrances — a fortress for the day",
    whyItMatters: "These remembrances come from the authenticated collection Hisn al-Muslim. They take under five minutes and scholars describe them as protection, presence, and an opening of the day in Allah's remembrance.",
    source: "Hisn al-Muslim — authenticated adhkar",
  },
  {
    id: "istighfar",
    timeOfDay: "after_fajr",
    name: "Istighfar",
    arabicName: "استغفار",
    transliteration: "Istighfar",
    type: "dhikr",
    shortDescription: "Seeking forgiveness — one of the clearest Quranic connections to rizq",
    whyItMatters: "Allah says through Nuh ﷺ: Ask forgiveness of your Lord — He will send rain upon you, give you increase in wealth and children, and provide for you rivers. (Quran 71:10-12). The Prophet ﷺ also said: whoever makes istighfar regularly, Allah will make for him a way out of every difficulty. (Abu Dawud — graded hasan)",
    source: "Quran 71:10-12; Abu Dawud (hasan)",
  },
  {
    id: "salawat",
    timeOfDay: "after_fajr",
    name: "Salawat upon the Prophet ﷺ",
    arabicName: "الصلاة على النبي",
    transliteration: "Salawat ʿala al-Nabi",
    type: "dhikr",
    shortDescription: "Blessings upon the Prophet ﷺ — tenfold return",
    whyItMatters: "Allah commands it in the Quran (33:56). The Prophet ﷺ said: whoever sends salawat upon me once, Allah sends blessings upon him tenfold. Ibn al-Qayyim describes salawat as opening closed doors and bringing barakah in time and affairs.",
    source: "Quran 33:56; Sahih Muslim; Jalaa al-Afhaam by Ibn al-Qayyim",
  },
  {
    id: "duha",
    timeOfDay: "forenoon",
    name: "Duha prayer",
    arabicName: "صلاة الضحى",
    transliteration: "Salat al-Duha",
    type: "prayer",
    shortDescription: "The prayer of gratitude for your body and its capacity to earn",
    whyItMatters: "The Prophet ﷺ said duha serves as sadaqah for every joint in the body. Scholars call it salat al-awwabeen — prayer of those who return often to Allah. It is a way of giving thanks for the ability to earn, and shukr is itself a cause of increase (Quran 14:7).",
    source: "Sahih Muslim; Quran 14:7",
  },
  {
    id: "evening_adhkar",
    timeOfDay: "evening",
    name: "Evening adhkar",
    arabicName: "أذكار المساء",
    transliteration: "Adhkar al-Masaa",
    type: "dhikr",
    shortDescription: "The mirror of the morning — closing the day in Allah's remembrance",
    whyItMatters: "From the same authenticated collections as the morning adhkar. Scholars describe them as protection as the day closes — a way to end work hours in consciousness of Allah rather than distraction.",
    source: "Hisn al-Muslim — authenticated adhkar",
  },
  {
    id: "quran",
    timeOfDay: "night",
    name: "Quran recitation",
    arabicName: "تلاوة القرآن",
    transliteration: "Tilawat al-Quran",
    type: "quran",
    shortDescription: "A daily portion — consistency over quantity",
    whyItMatters: "The Prophet ﷺ said the deeds most beloved to Allah are the most consistent, even if small. A daily wird of Quran — even a few ayat with reflection — keeps the heart connected. No specific surah is required. The connection matters more than the amount.",
    source: "Sahih al-Bukhari; Sahih Muslim",
  },
  {
    id: "muhasabah",
    timeOfDay: "night",
    name: "Muhasabah",
    arabicName: "محاسبة",
    transliteration: "Muhasabah",
    type: "reflection",
    shortDescription: "Self-accounting before sleep — did I earn halally and spend with intention?",
    whyItMatters: "Umar ibn al-Khattab said: call yourselves to account before you are called to account. This practice of honest self-review before sleep connects directly to what Barakah Budget is for: spending with awareness and intention. It takes two minutes and resets the heart.",
    source: "Narrated from Umar ibn al-Khattab — widely cited by scholars",
  },
];

export const TIME_LABELS = {
  night_pre_fajr: { label: "Night / Before Fajr", icon: "🌙" },
  after_fajr:     { label: "After Fajr",           icon: "🌅" },
  forenoon:       { label: "Forenoon (Duha)",       icon: "☀️" },
  evening:        { label: "Evening",               icon: "🌆" },
  night:          { label: "Night",                 icon: "🌙" },
};
